/* eslint-disable react/prop-types */
import Box from "components/Box";
import Typography from "components/Typography";
import Avatar from "components/Avatar";
import Badge from "components/Badge";
import { useGetFilterCategory } from "queries/ProductQuery";
import Table from "examples/Tables/Table";
import { Icon,TextField, Button,Pagination  } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";

function Category({ image, name, desc }) {
  return (
    <Box display="flex" alignItems="center" px={1} py={0.5}>
      <Box mr={2}>
        <Avatar src={image} alt={name} size="sm" variant="rounded" />
      </Box>
      <Box display="flex" flexDirection="column">
        <Typography variant="button" fontWeight="medium">
          {name}
        </Typography>
        <Typography variant="caption" color="secondary">
          {desc.slice(0,30)}
        </Typography>
      </Box>
    </Box>
  );
}

const TableData = () => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [sortBy, setSortBy] = useState('createdAt');
  const [order, setOrder] = useState('desc');
  const [search, setSearch] = useState('');


  const { data, isLoading } = useGetFilterCategory({ page, perPage, sortBy, order, search });

  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const columns = [
    { name: "category", align: "left" },
    { name: "status", align: "center" },
    { name: "createdon", align: "center" },
    { name: "Lastupdated", align: "center" },
    { name: "Important", align: "center" },
    { name: "action", align: "center" },
  ]

  const rows = data?.docs?.map(item => ({
    category: <Category image={`${process.env.REACT_APP_API_URL}/uploads/${item?.image}`} name={item?.name} desc={item?.desc} />,
    status: (
      <Badge variant="gradient" badgeContent={item?.isAvailable ? 'Available' : 'Unavailable'} color={item?.isAvailable ? "success" : 'secondary'} size="xs" container />
    ),
   
    createdon: (
      <Typography variant="caption" color="secondary" fontWeight="medium">
        {new Date(item?.createdAt).toDateString()}
      </Typography>
    ),
    Lastupdated: (
      <Typography variant="caption" color="secondary" fontWeight="medium">
        {new Date(item?.updatedAt).toDateString()}
      </Typography>
    ),
    Important: (
      <Badge variant="gradient" badgeContent={item?.isImportant ? 'Important' : 'Not-Important'} color={item?.isImportant ? "success" : 'secondary'} size="xs" container />
    ),
    action: (
      <Link to={`/category/editCategory/${item?._id}`}>
        <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small">
          more_vert
        </Icon>
      </Link>
    ),
  }))
  // return isLoading ? <Typography fontSize={14} sx={{ paddingX: 5 }}>loading...</Typography> : <Table columns={columns} rows={rows} />
return(
  <>
  <Box display="flex" alignItems="center" justifyContent="space-between" py={2}>
    <TextField
      placeholder="Search..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      variant="outlined"
      size="small"
      style={{marginLeft:'5px'}}
    />
    <Box>
      <Button onClick={() => setOrder(order === 'asc' ? 'desc' : 'asc')}>
        Sort by {sortBy} ({order})
      </Button>
    </Box>
  </Box>
  {isLoading ? (
    <Typography fontSize={14} sx={{ paddingX: 5 }}>loading...</Typography>
  ) : (
    <Table columns={columns} rows={rows} />
  )}
  <Box style={{display:'flex',justifyContent:'center', Margin:'10px'}}>
    <Pagination
      count={Math.ceil((data?.totalDocs || 0) / perPage)}
      page={page}
      onChange={handlePageChange}
    />
  </Box>
</>
)
};

export default TableData;
